import { styled } from "@mui/material";
import { AppHeader } from "@odl/core";
import darkLogo from "assets/images/logo-dark.svg";
import lightLogo from "assets/images/logo.svg";
import { urlHelper } from "components/RouteController/functions/urlHelper";
import ThemeModeContext from "components/ThemeModeProvider/ThemeModeContext";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const AppHeaderBar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnLogoClick = React.useCallback(() => {
    navigate(urlHelper.getURLForBasePage());
  }, [navigate]);

  const { themeMode } = React.useContext(ThemeModeContext);

  const logo = React.useMemo(() => {
    return themeMode === "dark" ? darkLogo : lightLogo;
  }, [themeMode]);

  return (
    <AppHeader brand="planbuild" data-testid="AppHeader">
      <StyledHeader>
        <StyledButton onClick={handleOnLogoClick}>
          <StyledLogo src={logo} alt={t("Build Australia logo")} />
        </StyledButton>
      </StyledHeader>
    </AppHeader>
  );
};

export default AppHeaderBar;

const StyledHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  minHeight: "44px",
  justifyContent: "space-between",
  zIndex: 9,
  padding: "0 12px",
  boxSizing: "border-box",
}));

const StyledButton = styled("button")(({ theme }) => ({
  border: "none",
  background: "none",
  boxShadow: "none",
  padding: 0,
  display: "flex",
}));

const StyledLogo = styled("img")(({ theme }) => ({
  cursor: "pointer",
  width: "160px",
}));
